<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'FormQuillEditor',
  components: {
    quillEditor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    titulo: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      content: this.value,
      charCount: 0,
      isTruncating: false,
      editorOptions: {
        theme: 'snow',
        placeholder: 'Escribe aquí...',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['link'],
            ['clean']
          ]
        }
      }
    }
  },
  watch: {
    content(val) {
      if (this.isTruncating) return;

      const div = document.createElement('div');
      div.innerHTML = val;

      const plainText = div.textContent || div.innerText || '';
      this.charCount = plainText.length;

      if (this.charCount > 120) {
        const truncatedText = plainText.slice(0, 120);

        const editor = this.$refs.editor.quill;
        this.isTruncating = true;
        editor.setText(truncatedText);
        this.content = editor.root.innerHTML;
        this.isTruncating = false;

        this.charCount = 120;
      }

      this.$emit('input', this.content);
      this.$emit('valid-state', this.charCount <= 120);
    }
  }
}
</script>

<template>
  <div class="fill-width w-100">
    <label class="titleslight--text">{{ titulo }}</label>
    <span class="titleslight--text font-weight-bold ml-1">*</span>

    <quill-editor
      ref="editor"
      v-model="content"
      :options="editorOptions"
      :class="['bg-white', charCount >= 120 ? 'editor-limit' : '']"
      :title="charCount >= 120 ? 'Límite de caracteres alcanzado' : ''"
    />

    <div class="mt-2" :class="charCount >= 120 ? 'text-red' : 'text-grey'">
      Caracteres: {{ charCount }}/120
      <span v-if="charCount >= 120"> – Límite alcanzado</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.text-red {
  color: red;
}
.text-grey {
  color: #666;
}
.editor-limit >>> .ql-container {
  border: 2px solid red !important;
  border-radius: 4px;
  cursor: help;
}
</style>
